import { cn } from '@/lib/shadcn/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-neutral-300', className)}
      {...props}
    />
  );
}

export { Skeleton };
